<ng-template #Employee>

    <div nxRow>
        <div nxCol="12" style="text-align: center;">
            <h3 nxHeadline="subsection-medium" translate *ngIf="!edit">
                policy.employees.new.title</h3>
            <h3 nxHeadline="subsection-medium" translate *ngIf="edit">
                policy.employees.edit.title</h3>
        </div>
    </div>

    <div nxRow *ngIf="!successFormSubmit; else successMsg">
        <div nxCol="12">
            <form [formGroup]="formEmployee" class="modal-form-new-employee" (submit)="submitEmployee($event)">

                <nx-formfield label="{{ 'policy.employees.data.name' | translate }}">
                    <input nxInput formControlName="name" type="text" />
                </nx-formfield>

                <nx-formfield label="{{ 'policy.employees.data.surname' | translate }}">
                    <input nxInput formControlName="surname" type="text" />
                </nx-formfield>

                <nx-formfield label="{{ 'policy.employees.data.birth-date' | translate }}" class="datepicker">
                    <input nxDatefield nxInput [datepicker]="dateDatepickerBirthDate"
                        [datefieldFilter]="filterBirthDate" formControlName="dateOfBirth"
                        [parseFormat]="['DD.MM.YYYY', 'D.M.YYYY']" displayFormat="DD.MM.YYYY" />
                    <nx-datepicker-toggle [for]="dateDatepickerBirthDate" nxFormfieldSuffix>
                    </nx-datepicker-toggle>
                    <nx-datepicker #dateDatepickerBirthDate></nx-datepicker>
                </nx-formfield>

                <nx-formfield label="{{ 'policy.employees.data.email' | translate }}">
                    <input nxInput formControlName="email" type="email" />
                    <span nxFormfieldHint>
                        example&#64;mail.com
                    </span>
                </nx-formfield>

                <nx-formfield label="{{ 'policy.employees.data.end-employment' | translate }}" class="datepicker"
                    *ngIf="edit">
                    <input nxDatefield nxInput [datepicker]="dateDatepickercanceledDate"
                        [datefieldFilter]="filtercanceledDate" formControlName="canceledDate"
                        [parseFormat]="['DD.MM.YYYY', 'D.M.YYYY']" displayFormat="DD.MM.YYYY" />
                    <nx-datepicker-toggle [for]="dateDatepickercanceledDate" nxFormfieldSuffix>
                    </nx-datepicker-toggle>
                    <nx-datepicker #dateDatepickercanceledDate></nx-datepicker>
                </nx-formfield>



                <nx-formfield label="{{ 'policy.employees.data.department' | translate }}">
                    <input nxInput formControlName="department" type="text" />
                </nx-formfield>

                <div nxRow>
                    <div nxCol="12" class="form-buttons">
                        <button nxButton="secondary small-medium" type="button" (click)="closeModal()"><span
                                translate>policy.employees.back-btn</span></button>
                        <button nxButton="primary small-medium" type="submit"><span
                                translate>policy.employees.new.submit-btn</span></button>
                    </div>
                </div>

            </form>
        </div>
    </div>

    <ng-template #successMsg>
        <div nxRow>
            <div nxCol="12" class="text-center">
                <h3 class="nx-font-weight-light" translate>
                    policy.employees.edit.success-text</h3>
            </div>
            <div nxCol="12" class="text-center">
                <button nxButton="primary normal" (click)="reloadContent()" type="button"><span
                        translate>policy.employees.ok-btn</span></button>
            </div>
        </div>
    </ng-template>

</ng-template>